var e = require("react"),
  n = {
    display: "block",
    opacity: 0,
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: -1
  },
  t = function (t) {
    var r = t.onResize,
      u = e.useRef();
    return function (n, t) {
      var r = function () {
        return n.current && n.current.contentDocument && n.current.contentDocument.defaultView;
      };
      function u() {
        t();
        var e = r();
        e && e.addEventListener("resize", t);
      }
      e.useEffect(function () {
        return r() ? u() : n.current && n.current.addEventListener && n.current.addEventListener("load", u), function () {
          var e = r();
          e && "function" == typeof e.removeEventListener && e.removeEventListener("resize", t);
        };
      }, []);
    }(u, function () {
      return r(u);
    }), e.createElement("iframe", {
      style: n,
      src: "about:blank",
      ref: u,
      "aria-hidden": !0,
      tabIndex: -1,
      frameBorder: 0
    });
  },
  r = function (e) {
    return {
      width: null != e ? e.offsetWidth : null,
      height: null != e ? e.offsetHeight : null
    };
  };
module.exports = function (n) {
  void 0 === n && (n = r);
  var u = e.useState(n(null)),
    o = u[0],
    i = u[1],
    c = e.useCallback(function (e) {
      return i(n(e.current));
    }, [n]);
  return [e.useMemo(function () {
    return e.createElement(t, {
      onResize: c
    });
  }, [c]), o];
};